import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import ProfileWizard from '../../components/va/ProfileWizard';
import Icon from '../../components/AppIcon';

const ONBOARDING_BENEFITS = [
  { icon: 'Briefcase', text: 'Get discovered by top employers looking for your skills' },
  { icon: 'DollarSign', text: 'Set your rates and availability to attract the right clients' },
  { icon: 'Award', text: 'Showcase verified skills and stand out from the crowd' },
  { icon: 'Star', text: 'Build a compelling portfolio that wins more opportunities' },
];

const VAOnboarding = () => {
  const navigate = useNavigate();
  const { userProfile } = useAuth();

  const finishOnboarding = () => {
    if (userProfile?.id) {
      localStorage.setItem(`va_started_profile_${userProfile.id}`, 'true');
    }
    navigate('/va-dashboard');
  };

  return (
    <div className="min-h-screen bg-background">
      <main className="pt-6 pb-20 md:pb-8">
        <div className="content-container">

          {/* Welcome Hero */}
          <div className="bg-gradient-to-r from-primary to-accent rounded-xl p-8 mb-8 text-white">
            <div className="flex items-start justify-between">
              <div>
                <h1 className="text-3xl font-bold mb-3">
                  Welcome to VA Sprouts{userProfile?.full_name ? `, ${userProfile.full_name.split(' ')[0]}` : ''}!
                </h1>
                <p className="text-lg text-white/90 mb-6 max-w-2xl">
                  Let's set up your VA profile so employers can find you and you can start landing great opportunities.
                  A complete profile gets <strong>3× more views</strong> and significantly more interview requests.
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {ONBOARDING_BENEFITS.map((benefit) => (
                    <div key={benefit.text} className="flex items-center gap-2 text-white/90">
                      <Icon name={benefit.icon} size={18} className="text-white flex-shrink-0" />
                      <span className="text-sm">{benefit.text}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Profile Wizard */}
          <div className="mx-auto">
            <ProfileWizard onSuccess={finishOnboarding} />
          </div>

          {/* Skip Link */}
          <div className="text-center mt-6 mb-8">
            <button
              onClick={finishOnboarding}
              className="text-sm text-text-tertiary hover:text-text-secondary transition-colors underline"
            >
              Skip for now — I'll complete my profile later
            </button>
          </div>

        </div>
      </main>
    </div>
  );
};

export default VAOnboarding;
